export default function() {
  this.$router.push({ name: this.pageSettings.sectionName + '.index' })
}